/* @flow */

// $FlowFixMe
module.exports = require('./dist/jsx-pragmatic'); // eslint-disable-line import/no-commonjs
